<p-dialog [header]="dialogHeader" [modal]="true" [responsive]="true" [(visible)]="displayAddImport"
    [style]="{width: '60vw'}" (onHide)="closeDialog()" styleClass="import-details-dialog">

    <app-subscription-limit-message *ngIf="subscriptionLimitReached" [subscriptionLimit]="subscriptionLimit"
        [moduleName]="'Import'">
    </app-subscription-limit-message>

    <div class="card" [ngClass]="{'p-d-none': subscriptionLimitReached}">
        <div class="p-grid">
            <div class="p-col-12 p-lg-6">
                <label class="p-text-bold">Module Name</label>
                <p-dropdown [options]="importModules"
                    [(ngModel)]="selectedModule"
                    [filter]="true"
                    optionLabel="name"
                    appendTo="body"
                    placeholder="Select Module"
                    [disabled]="disableModuleChange"
                    (onChange)="getChannels()">
                </p-dropdown>
            </div>
            <div *ngIf="![journalModuleId,contactModuleId, workspaceModuleId, SOModuleId, invoiceOrderModuleId, cmOrderModuleId].includes(selectedModule?.id)" class="p-col-12 p-lg-6">
                <label class="p-text-bold">Channel Name</label>
                <p-dropdown [options]="moduleChannels"
                    [(ngModel)]="selectedChannel"
                    [filter]="true"
                    optionLabel="name"
                    placeholder="Select Channel"
                    appendTo="body"
                    [disabled]="disableModuleChange">
                </p-dropdown>
            </div>

            <div *ngIf="[workspaceModuleId].includes(selectedModule?.id)"  class="p-col-12 p-lg-6">
                <label class="p-text-bold">Workspace Name</label>
                <p-dropdown [options]="worspaceList"
                    [(ngModel)]="selectedWorkspace"
                    optionLabel="name"
                    placeholder="Select Workspace"
                    appendTo="body"
                    [filter]="true"
                    (onChange)="onWorkspaceChange()"
                    [disabled]="disableModuleChange"
                    [resetFilterOnHide]="true"
                    >
                </p-dropdown>
            </div>

            <div *ngIf="[workspaceModuleId].includes(selectedModule?.id)" class="p-col-12 p-lg-6">
                <label class="p-text-bold">Workbook Name</label>
                <p-dropdown [options]="workBookList"
                    [(ngModel)]="selectedWorkbook"
                    optionLabel="name"
                    placeholder="Select Workbook"
                    appendTo="body"
                    [filter]="true"
                    [disabled]="disableModuleChange"
                    [resetFilterOnHide]="true"
                    >
                </p-dropdown>
            </div>
        </div>
        <hr>
        <ng-container *ngIf="shouldShowActionButtons()">
        <div class="p-grid">
            <div class="p-col-12 p-lg-6">
                <label class="p-text-bold">Action</label>
                <ng-container *ngFor="let action of (importActions|importActionFilter:selectedModule?.id)" class="p-field-checkbox">
                    <p-radioButton name="action" [value]="action" [(ngModel)]="selectedAction"></p-radioButton>&nbsp;{{action?.name}}
                </ng-container>
            </div>
            <div class="p-col-12 p-lg-6">
                <label class="pointer" style="color: var(--primary-color); width: fit-content; float: right;"
                    [class.disable-download-btn]="getDisableValues()"
                    (click)="downloadSampleFile()">
                    <span class="pi pi-download"></span>
                    Download Sample File
                </label>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12">
                <p-fileUpload [files]="importFiles" name="files[]"
                    (onUpload)="onUpload($event)" (onSelect)="onSelect($event)"
                    (onClear)="onClear()" (onRemove)="onRemove()"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    maxFileSize="10000000" [showUploadButton]="false" #uploader>
                </p-fileUpload>
            </div>
        </div>
    </ng-container>
    </div>

    <p-footer>
        <button type="button" pButton label="Next" (click)="mapImportField()" [disabled]="!(uploader && uploader?.files?.length > 0) || getDisableValues()"></button>
    </p-footer>
</p-dialog>

<app-shared-import-sample-modal *ngIf="displayImportSample"
    [showOnlyRequiredSelected]="true"
    [displayImportSample]="displayImportSample"
    [selectedModule]="selectedModule"
    [sectionColumns]="sectionColumns"
    (dialogClosed)="closeSampleModal()">
</app-shared-import-sample-modal>

<app-shared-import-field-mapping *ngIf="displayFieldMapping"
    [displayFieldMapping]="displayFieldMapping"
    [selectedModule]="selectedModule"
    [selectedChannel]="selectedChannel"
    [sectionColumns]="sectionColumns"
    [selectedWorkbook] = "selectedWorkbook"
    [selectedWorkspace] = "selectedWorkspace"
    [selectedFile]="selectedFile"
    [selectedFileHeaders]="selectedFileHeaders"
    [selectedAction]="selectedAction"
    (dialogClosed)="closMappingModal()"
    (importStarted)="importFileUploaded()">
</app-shared-import-field-mapping>
